import { SessionDeprecatedService } from '@commons/core/auth/session-deprecated.service';
import { IHttpService, IPromise, IQService } from 'angular';

import { RequestBuilder } from './request-builder';

export class AsPromiseRequestBuilder extends RequestBuilder<IPromise<any>> {
  /**
   * Creates an instance of RequestBuilder.
   * @param {IHttpService} http angular service
   * @param {any} sessionDeprecatedService session service
   * @param {string} baseUrl REST base URL
   */
  constructor(
    public readonly $q: IQService,
    protected override readonly $http: IHttpService,
    protected override readonly sessionDeprecatedService: SessionDeprecatedService,
    protected override readonly baseUrl: string
  ) {
    super($http, sessionDeprecatedService, baseUrl);
  }

  get(path: string, pathParams?: (string | number | boolean)[]): IPromise<any> {
    return this.$http.get(this.buildUrl(path, pathParams), this.config);
  }

  head(path: string, pathParams?: (string | number | boolean)[]): IPromise<any> {
    return this.$http.head(this.buildUrl(path, pathParams), this.config);
  }

  post(path: string, pathParams?: (string | number | boolean)[]): IPromise<any> {
    return this.$http.post(this.buildUrl(path, pathParams), this.data, this.config);
  }

  put(path: string, pathParams?: (string | number | boolean)[]): IPromise<any> {
    return this.$http.put(this.buildUrl(path, pathParams), this.data, this.config);
  }

  delete(path: string, pathParams?: (string | number | boolean)[]): IPromise<any> {
    return this.$http.delete(this.buildUrl(path, pathParams), this.config);
  }

  jsonp(path: string, pathParams?: (string | number | boolean)[]): IPromise<any> {
    return this.$http.jsonp(this.buildUrl(path, pathParams), this.config);
  }

  patch(path: string, pathParams?: (string | number | boolean)[]): IPromise<any> {
    return this.$http.patch(this.buildUrl(path, pathParams), this.data, this.config);
  }
}
